import { ADD_EMPLOYEE_FORM_TRANSLATIONS } from 'const/translations';
import Styles from './SharedNotification.module.css';

export const SharedNotification = () => (
  <div className={Styles.notificationWrapper}>
    {ADD_EMPLOYEE_FORM_TRANSLATIONS.NOTIFICATION}
  </div>
);
